export const MODULE_PERMISSIONS_UPDATED = "dental-os:module-permissions-updated";

export const CLINIC_MODULE_KEYS = Object.freeze([
  "chairside",
  "treatment_plans",
  "ortho",
  "checkout",
  "accounts_receivable",
  "hmo_claims",
  "inventory",
  "reports",
  "expenses",
  "support",
]);

export function modulePermissionRowsToAccess(rows) {
  const access = Object.fromEntries(CLINIC_MODULE_KEYS.map((key) => [key, false]));
  (Array.isArray(rows) ? rows : []).forEach((row) => {
    if (Object.prototype.hasOwnProperty.call(access, row?.module_key)) {
      access[row.module_key] = row.allowed === true;
    }
  });
  return access;
}

export function canAccessClinicModule(moduleAccess, moduleKey) {
  if (!CLINIC_MODULE_KEYS.includes(moduleKey)) return false;
  return moduleAccess?.[moduleKey] === true;
}
